import { ref, Ref, unref } from '@vue/composition-api';
import {
    IPartialPaymentPopup,
} from '@ve/components/partialPayment/partialPaymentPopup/common/types/IPartialPaymentPopup';

interface IReturn {
    openPopup():void;
    partialPaymentPopupRef: Ref<IPartialPaymentPopup | null>;
}

const usePartialPaymentPopupRef = ():IReturn => {
    const partialPaymentPopupRef: Ref<IPartialPaymentPopup | null> = ref(null);

    const openPopup = () => {
        unref(partialPaymentPopupRef)?.openPopup();
    };

    return {
        openPopup,
        partialPaymentPopupRef,
    };
};

export default usePartialPaymentPopupRef;